export default "__VITE_ASSET__nu_BgZwp__"